import { useCallback, useState } from 'react';

const getDefaultFetchMoreArgs = (): unknown[] => [];

const usePaginatedResults = <A extends unknown[]>({
  fetchMore,
  getFetchMoreArgs = getDefaultFetchMoreArgs as () => A,
  hasMore,
  isLoadingData,
  isReady,
}: {
  fetchMore: (...args: A) => void;
  getFetchMoreArgs?: () => A;
  hasMore: boolean;
  isLoadingData: boolean;
  isReady: boolean;
}) => {
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false);

  const markFetchedOnce = useCallback(() => {
    setHasFetchedOnce(true);
  }, []);

  const isLoading = !isReady || !hasFetchedOnce || isLoadingData;

  const fetchMoreResults = useCallback(() => {
    if (!isLoading && hasMore) {
      fetchMore(...getFetchMoreArgs());
    }
  }, [fetchMore, getFetchMoreArgs, hasMore, isLoading]);

  return { fetchMoreResults, hasFetchedOnce, isLoading, markFetchedOnce };
};

export default usePaginatedResults;
